<template>
    <li class="coupon-item" @click="useConpon" :class="styleClass">
        <div class="price-info">
            <div class="price-number">
                <em v-if="!isDiscountType">¥</em>
                <span>{{ couponInfo.couponValue }}</span>
                <em v-if="isDiscountType">折</em>
            </div>
            <div class="counpon-type">
                <span>{{ couponInfo.couponTypeAlias }}</span>
            </div>
        </div>
        <div class="coupon-info">
            <div class="coupon-name">
                <span>{{ couponInfo.couponName }}</span>
            </div>
            <div class="coupon-scope">
                <span>{{ couponInfo.effect }}</span>
            </div>
            <div class="coupon-value">
                <span>{{ couponInfo.couponQuotaExplain }}</span>
            </div>
            <div class="counpon-time">
                <span
                    >{{ couponInfo.startTime }} - {{ couponInfo.endTime }}</span
                >
            </div>
        </div>
    </li>
</template>
<script>
import {
    COMMON_TYPE_CONPON,
    COMMON_VARIETY_COUPON,
    UNLIMITED_TYPE_COUPON,
    CATEGORY_VARIETY_COUPON,
    SKU_VARIETY_COUPON,
    REDPACKET_TYPE_COUPON,
    POSTAGE_TYPE_COUPON,
    DISCOUNT_TYPE_COUPON,
    BRAND_VARIETY_COUPON,
    POSTAGE_VARIETY_COUPON,
} from "../../../../definition/type/coupon";
export default {
    name: "CouponItem",
    props: {
        couponInfo: {
            //优惠券信息
            type: Object,
            required: true,
        },
        status: {
            //优惠券状态
            type: [Number],
            default: 100,
        },
    },
    data() {
        return {};
    },
    methods: {
        /**
         * @description 使用优惠券
         */
        useConpon() {
            this.$emit("use", this.couponInfo);
        },
    },
    computed: {
        couponType() {
            let typeMap = {
                0: "普通满减券",
                1: "上不封顶满减券",
                2: "红包券",
                3: "折扣券",
                4: "运费券",
            };
            return typeMap[`${this.couponInfo.couponType}`];
        },
        isDiscountType() {
            let { couponType } = this.couponInfo;
            let isDiscountType = couponType == DISCOUNT_TYPE_COUPON;
            return isDiscountType;
        },
        styleClass() {
            //优惠券类型
            let {
                couponType,
                useFlag,
                invalidFlag,
                disabled,
                checkedFlag,
                couponVariety,
            } = this.couponInfo;
            const USE_STATUS = 200;
            const PAST_STATUS = 300;
            return {
                "select-active": checkedFlag,
                "coupon-bg":
                    (couponVariety == COMMON_VARIETY_COUPON &&
                        couponType == UNLIMITED_TYPE_COUPON) ||
                    couponType == COMMON_TYPE_CONPON ||
                    (couponVariety == BRAND_VARIETY_COUPON &&
                        couponType != REDPACKET_TYPE_COUPON) ||
                    (couponVariety == CATEGORY_VARIETY_COUPON &&
                        couponType != REDPACKET_TYPE_COUPON) ||
                    (couponVariety == SKU_VARIETY_COUPON &&
                        couponType != REDPACKET_TYPE_COUPON) ||
                    couponType == DISCOUNT_TYPE_COUPON,
                "bag-bg": couponType == REDPACKET_TYPE_COUPON,
                "postage-bg": couponVariety == POSTAGE_VARIETY_COUPON,
                "use-status": useFlag || false,
                "past-status": invalidFlag || false,
                "disabled-status": disabled || false,
            };
        },
    },
};
</script>
<style lang="less">
.coupon-item {
    overflow: hidden;
    margin-bottom: 20px;
    width: 710px;
    height: 200px;
    background-size: 710px 200px;
    &.select-active {
        .counpon-time {
            background-image: url("../../../../public/images/user/coupon/coupon-select-active.png");
            background-repeat: no-repeat;
            background-size: 24px;
            background-position: right bottom;
        }
    }
    &.coupon-bg {
        background-image: url("../../../../public/images/user/coupon/coupon-bg.png");
        &.use-status {
            background-image: url("../../../../public/images/user/coupon/coupon-use-bg.png");
        }
        &.past-status {
            background-image: url("../../../../public/images/user/coupon/coupon-past-bg.png");
        }
        &.disabled-status {
            background-image: url("../../../../public/images/user/coupon/disabled-bg.png");
        }
    }
    &.bag-bg {
        background-image: url("../../../../public/images/user/coupon/bag-bg.png");
        &.use-status {
            background-image: url("../../../../public/images/user/coupon/bag-use-bg.png");
        }
        &.past-status {
            background-image: url("../../../../public/images/user/coupon/bag-past-bg.png");
        }
        &.disabled-status {
            background-image: url("../../../../public/images/user/coupon/disabled-bg.png");
        }
    }
    &.postage-bg {
        background-image: url("../../../../public/images/user/coupon/postage-bg.png");
        &.use-status {
            background-image: url("../../../../public/images/user/coupon/coupon-use-bg.png");
        }
        &.past-status {
            background-image: url("../../../../public/images/user/coupon/coupon-past-bg.png");
        }
        &.disabled-status {
            background-image: url("../../../../public/images/user/coupon/disabled-bg.png");
        }
    }
    > .price-info {
        float: left;
        padding-top: 40px;
        width: 235px;
        height: 160px;
        > .price-number {
            text-align: center;
            font-size: 60px;
            color: #fff;
            em {
                padding-right: 5px;
                font-size: 34px;
                font-weight: 600;
            }
        }
        .counpon-type {
            height: 36px;
            font-size: 26px;
            line-height: 36px;
            text-align: center;
            color: #fff;
        }
    }
    > .coupon-info {
        float: right;
        width: 470px;
        height: 200px;
        .coupon-name {
            margin: 20px auto 6px;
            font-size: 28px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            color: #333;
        }
        .coupon-scope {
            margin: 0 auto 8px;
            height: 26px;
            font-size: 24px;
            line-height: 26px;
            color: #666666;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .coupon-value {
            height: 34px;
            font-size: 24px;
            line-height: 34px;
            color: #666666;
            text-align: center;
        }
        .counpon-time {
            position: relative;
            margin: 26px auto 0;
            height: 28px;
            font-size: 20px;
            line-height: 28px;
            color: #666;
            text-align: center;
        }
    }
}
</style>
